module.exports = __webpack_public_path__ + "img/t_3.9479d41f.png";